export default "__VITE_ASSET__LZHb$EIJ__"